export const browserFaqs = {
  chrome: {
    title: "¿Cómo habilitar cookies de terceros en Chrome en tu computadora?",
    content: `
    <div class="browser-faqs-hero">
      <h2 class="browser-faqs-title">¿Cómo habilitar cookies de terceros en Chrome en tu computadora?</h2>
      <figure class="browser-faqs-img">
        <img src="https://www.clarin.com/images/collections/faqs/chrome-screen___68ffa929052c970019fbe6bc.png" alt="Chrome"/>
      </figure>
    </div>

    <div class="browser-faqs-step left-img">
      <figure class="browser-faqs-step-img">
        <img src="https://www.clarin.com/images/collections/faqs/chrome-1___68ffa929c0ec7a001898852f.png" alt="Paso 1">
      </figure>
      <div class="browser-faqs-step-info">
        <p class="browser-faqs-step-title">Paso 1</p>
        <p class="browser-faqs-step-text">Hacé click en el símbolo <img class="small-img" src="https://www.clarin.com/images/collections/faqs/chrome-icn___68ffa92d052c970019fbe6bf.png" alt="Icono"> ubicado en la <span>esquina superior derecha</span> de tu navegador.</p>
      </div>
    </div>

    <div class="browser-faqs-step right-img">
      <div class="browser-faqs-step-info">
        <p class="browser-faqs-step-title">Paso 2</p>
        <p class="browser-faqs-step-text">Seleccioná la opción <span>“Configuración”.</span></p>
      </div>
      <figure class="browser-faqs-step-img">
        <img src="https://www.clarin.com/images/collections/faqs/chrome-2___68ffa929c0ec7a0018988530.gif" alt="Paso 2">
      </figure>
    </div>

    <div class="browser-faqs-step left-img">
      <figure class="browser-faqs-step-img">
        <img src="https://www.clarin.com/images/collections/faqs/chrome-3___68ffa92a052c970019fbe6be.gif" alt="Paso 3">
      </figure>
      <div class="browser-faqs-step-info">
        <p class="browser-faqs-step-title">Paso 3</p>
        <p class="browser-faqs-step-text">Escribí la palabra <span>“cookies”</span> en el <strong>buscador,</strong> ubicado en la parte superior azul.</p>
      </div>
    </div>

    <div class="browser-faqs-step right-img">
      <div class="browser-faqs-step-info">
        <p class="browser-faqs-step-title">Paso 4</p>
        <p class="browser-faqs-step-text">Hacé click en la opción <span>“configuración de contenido”,</span> ubicada debajo en la lista.</p>
      </div>
      <figure class="browser-faqs-step-img">
        <img src="https://www.clarin.com/images/collections/faqs/chrome-4___68ffa929052c970019fbe6bd.png" alt="Paso 4">   
      </figure> 
    </div>

    <div class="browser-faqs-step left-img">
      <figure class="browser-faqs-step-img">
        <img src="https://www.clarin.com/images/collections/faqs/chrome-5___68ffa92cc0ec7a0018988533.png" alt="Paso 5">
      </figure>
      <div class="browser-faqs-step-info">
        <p class="browser-faqs-step-title">Paso 5</p>
        <p class="browser-faqs-step-text">Hacé click en la opción <span>“Cookies”.</span></p>
      </div>
    </div>

    <div class="browser-faqs-step right-img">
      <div class="browser-faqs-step-info">
        <p class="browser-faqs-step-title">Paso 6</p>
        <p class="browser-faqs-step-text"><strong>Apagá el botón</strong> ubicado a la derecha de la opción <span>“bloquear cookies de terceros”,</span> haciendo click sobre él.<br><br><em>* Para asegurarte que el bloqueo fue desactivado, corroborá que el botón haya quedado gris, como se muestra en la imagen enmarcada.</em></p>
      </div>
      <figure class="browser-faqs-step-img">
        <img src="https://www.clarin.com/images/collections/faqs/chrome-6___68ffa92ac0ec7a0018988532.gif" alt="Paso 6"> 
      </figure>   
    </div>

    <div class="browser-faqs-step left-img">
      <figure class="browser-faqs-step-img">
        <img src="https://www.clarin.com/images/collections/faqs/chrome-7___68ffa92ac0ec7a0018988531.gif" alt="Paso 7">
      </figure>
      <div class="browser-faqs-step-info">
        <p class="browser-faqs-step-title">Paso 7</p>
        <p class="browser-faqs-step-text">Finalmente ingresá a <span>Clarin.com</span> para continuar leyendo sin problemas.</p>
      </div>
    </div>

    <div class="browser-faqs-others">
        <p class="browser-faqs-others-title">También te puede interesar</p>
        <div class="browser-faqs-others-options">
            <a class="browser-faqs-others-options-link" href="https://www.clarin.com/preguntas-frecuentes/safari.html">¿Cómo habilitar cookies de terceros en navegadores Safari para MAC?</a>
            <a class="browser-faqs-others-options-link" href="https://www.clarin.com/preguntas-frecuentes/ios.html">¿Cómo habilitar cookies de terceros en navegadores Safari para iPhone & iPad?</a>
            <a class="browser-faqs-others-options-link" href="https://www.clarin.com/preguntas-frecuentes/ie.html">¿Cómo habilitar cookies de terceros en navegadores Explorer?</a>
            <a class="browser-faqs-others-options-link" href="https://www.clarin.com/preguntas-frecuentes/firefox.html">¿Cómo habilitar cookies de terceros en navegadores Firefox?</a>
            <a class="browser-faqs-others-options-link" href="https://www.clarin.com/preguntas-frecuentes">Preguntas frecuentes</a>
        </div>
    </div>
    `,
  },

  firefox: {
    title:
      "¿Cómo habilitar cookies de terceros en Mozilla Firefox en tu computadora?",
    content: `
    <div class="browser-faqs-hero">
      <h2 class="browser-faqs-title">¿Cómo habilitar cookies de terceros en Mozilla Firefox en tu computadora?</h2>
      <figure class="browser-faqs-img">
        <img src="https://www.clarin.com/images/collections/faqs/firefox-screen___68ffadbdc0ec7a0018988534.png" alt="Firefox"/>
      </figure>
    </div>

    <div class="browser-faqs-step left-img">
      <figure class="browser-faqs-step-img">
        <img src="https://www.clarin.com/images/collections/faqs/firefox-1___68ffadbf052c970019fbe6c2.png" alt="Paso 1">
      </figure>
      <div class="browser-faqs-step-info">
        <p class="browser-faqs-step-title">Paso 1</p>
        <p class="browser-faqs-step-text">Hacé click en el símbolo <img class="small-img" src="https://www.clarin.com/images/collections/faqs/firefox-icn___68ffadbd052c970019fbe6c1.png" alt="Icono"> ubicado en la <span>esquina superior derecha</span> de tu navegador.</p>
      </div>
    </div>

    <div class="browser-faqs-step right-img">
      <div class="browser-faqs-step-info">
        <p class="browser-faqs-step-title">Paso 2</p>
        <p class="browser-faqs-step-text">Seleccioná <span>“Opciones”.</span></p>
      </div>
      <figure class="browser-faqs-step-img">
        <img src="https://www.clarin.com/images/collections/faqs/firefox-2___68ffadbdc0ec7a0018988536.gif" alt="Paso 2" class="gif">
      </figure>
    </div>

    <div class="browser-faqs-step left-img">
      <figure class="browser-faqs-step-img">
        <img src="https://www.clarin.com/images/collections/faqs/firefox-3___68ffadbec0ec7a0018988537.gif" alt="Paso 3">
      </figure>
      <div class="browser-faqs-step-info">
        <p class="browser-faqs-step-title">Paso 3</p>
        <p class="browser-faqs-step-text">Escribí la palabra <span>“cookies”</span> en el buscador, el cual está ubicado en el centro superior de la página.</p>
      </div>
    </div>

    <div class="browser-faqs-step right-img">
      <div class="browser-faqs-step-info">
        <p class="browser-faqs-step-title">Paso 4</p>
        <p class="browser-faqs-step-text">Allí, verificá que la opción <span>“Aceptar cookies y datos de los sitios web”</span> se encuentre seleccionada.</p>
      </div>
      <figure class="browser-faqs-step-img">
        <img src="https://www.clarin.com/images/collections/faqs/firefox-4___68ffadbec0ec7a0018988538.png" alt="Paso 4">   
      </figure>  
    </div>

    <div class="browser-faqs-step left-img">
      <figure class="browser-faqs-step-img">
        <img src="https://www.clarin.com/images/collections/faqs/firefox-5___68ffadbdc0ec7a0018988535.png" alt="Paso 5">
      </figure>
      <div class="browser-faqs-step-info">
        <p class="browser-faqs-step-title">Paso 5</p>
        <p class="browser-faqs-step-text">También, tendrás que verificar que para el punto <strong>“Aceptar cookies de terceros y datos del sitio”</strong> deberá estar seleccionada la opción <span>“Siempre”.</span></p>
      </div>
    </div>

    <div class="browser-faqs-step right-img">
      <div class="browser-faqs-step-info">
        <p>Paso 6</p>
        <p>Finalmente ingresá a <span>Clarin.com</span> para continuar leyendo sin problemas.</p>
      </div>
      <figure class="browser-faqs-step-img">
        <img src="https://www.clarin.com/images/collections/faqs/firefox-6___68ffadbd052c970019fbe6c0.gif" alt="Paso 6"> 
      </figure>    
    </div>

    <div class="browser-faqs-others">
        <p class="browser-faqs-others-title">También te puede interesar</p>
        <div class="browser-faqs-others-options">
            <a class="browser-faqs-others-options-link" href="https://www.clarin.com/preguntas-frecuentes/safari.html">¿Cómo habilitar cookies de terceros en navegadores Safari para MAC?</a>
            <a class="browser-faqs-others-options-link" href="https://www.clarin.com/preguntas-frecuentes/chrome.html">¿Cómo habilitar cookies de terceros en navegadores Chrome?</a>
            <a class="browser-faqs-others-options-link" href="https://www.clarin.com/preguntas-frecuentes/ie.html">¿Cómo habilitar cookies de terceros en navegadores Explorer?</a>
            <a class="browser-faqs-others-options-link" href="https://www.clarin.com/preguntas-frecuentes/ios.html">¿Cómo habilitar cookies de terceros en navegadores Safari para iPhone & iPad?</a>
            <a class="browser-faqs-others-options-link" href="https://www.clarin.com/preguntas-frecuentes">Preguntas frecuentes</a>
        </div>
    </div>
    `,
  },

  ie: {
    title:
      "¿Cómo habilitar cookies de terceros en Internet Explorer en tu computadora?",
    content: `
    <div class="browser-faqs-hero">
      <h2 class="browser-faqs-title">¿Cómo habilitar cookies de terceros en Internet Explorer en tu computadora?</h2>
      <figure class="browser-faqs-img">
        <img src="https://www.clarin.com/images/collections/faqs/ie-screen___68ffb0ba052c970019fbe6c4.png" alt="Internet Explorer"/>
      </figure>
    </div>

    <div class="browser-faqs-step left-img">
      <figure class="browser-faqs-step-img">
        <img src="https://www.clarin.com/images/collections/faqs/ie-1___68ffb0bac0ec7a001898853a.png" alt="Paso 1">
      </figure>
      <div class="browser-faqs-step-info">
        <p class="browser-faqs-step-title">Paso 1</p>
        <p class="browser-faqs-step-text">Hacé click en el símbolo <img class="small-img" src="https://www.clarin.com/images/collections/faqs/ie-icn___68ffb0bbc0ec7a001898853c.png" alt="Icono"> ubicado en la <span>esquina superior derecha</span> de tu navegador.</p>
      </div>
    </div>

    <div class="browser-faqs-step right-img">
      <div class="browser-faqs-step-info">
        <p class="browser-faqs-step-title">Paso 2</p>
        <p class="browser-faqs-step-text">Seleccioná <span>“Opciones de Internet”.</span></p>
      </div>
      <figure class="browser-faqs-step-img">
        <img src="https://www.clarin.com/images/collections/faqs/ie-2___68ffb0bac0ec7a001898853b.gif" alt="Paso 2" class="gif">
      </figure>
    </div>

    <div class="browser-faqs-step left-img">
      <figure class="browser-faqs-step-img">
        <img src="https://www.clarin.com/images/collections/faqs/ie-3___68ffb0b9052c970019fbe6c3.gif" alt="Paso 3">
      </figure>
      <div class="browser-faqs-step-info">
        <p class="browser-faqs-step-title">Paso 3</p>
        <p class="browser-faqs-step-text">Se mostrará una ventana donde deberás dirigirte a la pestaña <span>“Privacidad”.</span> Allí <strong>mové la barra selectora</strong> hasta que visualices el texto <span>“Aceptar todas las Cookies”.</span></p>
      </div>
    </div>

    <div class="browser-faqs-step right-img">
      <div class="browser-faqs-step-info">
        <p class="browser-faqs-step-title">Paso 4</p>
        <p class="browser-faqs-step-text">Finalmente, deberás clickear en <span>“Aceptar”</span> y podrás seguir navegando sin problemas.</p>
      </div>
      <figure class="browser-faqs-step-img">
        <img src="https://www.clarin.com/images/collections/faqs/ie-4___68ffb0bac0ec7a0018988539.png" alt="Paso 4">
      </figure>     
    </div>

    <div class="browser-faqs-step left-img">
      <figure class="browser-faqs-step-img">
        <img src="https://www.clarin.com/images/collections/faqs/ie-5___68ffb0ba052c970019fbe6c5.gif" alt="Paso 5">
      </figure>
      <div class="browser-faqs-step-info">
        <p class="browser-faqs-step-title">Paso 5</p>
        <p class="browser-faqs-step-text">Finalmente ingresá a <span>Clarin.com</span> para continuar leyendo sin problemas.</p>
      </div>
    </div>

    <div class="browser-faqs-others">
        <p class="browser-faqs-others-title">También te puede interesar</p>
        <div class="browser-faqs-others-options">
            <a class="browser-faqs-others-options-link" href="https://www.clarin.com/preguntas-frecuentes/safari.html">¿Cómo habilitar cookies de terceros en navegadores Safari para MAC?</a>
            <a class="browser-faqs-others-options-link" href="https://www.clarin.com/preguntas-frecuentes/chrome.html">¿Cómo habilitar cookies de terceros en navegadores Chrome?</a>
            <a class="browser-faqs-others-options-link" href="https://www.clarin.com/preguntas-frecuentes/ios.html">¿Cómo habilitar cookies de terceros en navegadores Safari para iPhone & iPad??</a>
            <a class="browser-faqs-others-options-link" href="https://www.clarin.com/preguntas-frecuentes/firefox.html">¿Cómo habilitar cookies de terceros en navegadores Firefox?</a>
            <a class="browser-faqs-others-options-link" href="https://www.clarin.com/preguntas-frecuentes">Preguntas frecuentes</a>
        </div>
    </div>
    `,
  },

  safari: {
    title: "¿Cómo habilitar cookies de terceros en navegadores Safari?",
    content: `
    <div class="browser-faqs-hero">
      <h2 class="browser-faqs-title">¿Cómo habilitar cookies de terceros en navegadores Safari?</h2>
      <figure class="browser-faqs-img">
        <img src="https://www.clarin.com/images/collections/faqs/safari-screen___68ffb295c0ec7a001898853d.png" alt="Internet Explorer"/>
      </figure>
    </div>

    <div class="browser-faqs-step left-img">
      <figure class="browser-faqs-step-img">
        <img src="https://www.clarin.com/images/collections/faqs/safari-1___68ffb295c0ec7a001898853e.png" alt="Paso 1">
      </figure>
      <div class="browser-faqs-step-info">
        <p class="browser-faqs-step-title">Paso 1</p>
        <p class="browser-faqs-step-text">Abrí tu navegador <strong>Safari</strong> y hacé click en el botón <span>“Safari”,</span> ubicado en la esquina superior izquierda de la pantalla.</p>
      </div>
    </div>

    <div class="browser-faqs-step right-img">
      <div class="browser-faqs-step-info">
        <p class="browser-faqs-step-title">Paso 2</p>
        <p class="browser-faqs-step-text">Seleccioná la opción <span>“Preferencias”.</span></p>
      </div>
      <figure class="browser-faqs-step-img">
        <img src="https://www.clarin.com/images/collections/faqs/safari-2___68ffb295c0ec7a001898853f.gif" alt="Paso 2" class="gif">
      </figure>
    </div>

    <div class="browser-faqs-step left-img">
      <figure class="browser-faqs-step-img">
        <img src="https://www.clarin.com/images/collections/faqs/safari-3___68ffb297052c970019fbe6c7.gif" alt="Paso 3">
      </figure>
      <div class="browser-faqs-step-info">
        <p class="browser-faqs-step-title">Paso 3</p>
        <p class="browser-faqs-step-text">Hacé click en <span>“Privacidad”.</span></p>
      </div>
    </div>

    <div class="browser-faqs-step right-img">
      <div class="browser-faqs-step-info">
        <p class="browser-faqs-step-title">Paso 4</p>
        <p class="browser-faqs-step-text"><span>Desmarcá las tres opciones</span> que figuran debajo, haciendo click en los recuadros.<br><br><em>* Para asegurarte de que los ítems fueron deshabilitados, corroborá que cada una de las opciones haya quedado destildada/vacía, como se muestra en la imagen.</em></p>
      </div>
      <figure class="browser-faqs-step-img">
        <img src="https://www.clarin.com/images/collections/faqs/safari-4___68ffb297c0ec7a0018988540.gif" alt="Paso 4">
      </figure>    
    </div>

    <div class="browser-faqs-step left-img">
      <figure class="browser-faqs-step-img">
        <img src="https://www.clarin.com/images/collections/faqs/safari-5___68ffb296052c970019fbe6c6.gif" alt="Paso 5">
      </figure>
      <div class="browser-faqs-step-info">
        <p class="browser-faqs-step-title">Paso 5</p>
        <p class="browser-faqs-step-text">Finalmente ingresá a <span>Clarin.com</span> para continuar leyendo sin problemas.</p>
      </div>
    </div>

    <div class="browser-faqs-others">
        <p class="browser-faqs-others-title">También te puede interesar</p>
        <div class="browser-faqs-others-options">
            <a class="browser-faqs-others-options-link" href="https://www.clarin.com/preguntas-frecuentes/chrome.html">¿Cómo habilitar cookies de terceros en navegadores Chrome?</a>
            <a class="browser-faqs-others-options-link" href="https://www.clarin.com/preguntas-frecuentes/ios.html">¿Cómo habilitar cookies de terceros en navegadores Safari para iPhone & iPad??</a>
            <a class="browser-faqs-others-options-link" href="https://www.clarin.com/preguntas-frecuentes/firefox.html">¿Cómo habilitar cookies de terceros en navegadores Firefox?</a>
            <a class="browser-faqs-others-options-link" href="https://www.clarin.com/preguntas-frecuentes/ie.html">¿Cómo habilitar cookies de terceros en navegadores Explorer?</a>
            <a class="browser-faqs-others-options-link" href="https://www.clarin.com/preguntas-frecuentes">Preguntas frecuentes</a>
        </div>
    </div>
    `,
  },

  ios: {
    title: "¿Cómo desactivar las cookies en iPhone y iPad?",
    content: `
    <div class="browser-faqs-hero">
      <h2 class="browser-faqs-title">¿Cómo desactivar las cookies en iPhone y iPad?</h2>
      <figure class="browser-faqs-img">
        <img src="https://www.clarin.com/images/collections/faqs/ios-screen___68ff8e8d052c970019fbe6b9.png" />
      </figure>

    <div class="browser-faqs-step left-img">
      <figure class="browser-faqs-step-img">
        <img src="https://www.clarin.com/images/collections/faqs/ios-1___68ff8e8cc0ec7a001898852c.png" alt="Paso 1">
      </figure>
      <div class="browser-faqs-step-info">
        <p class="browser-faqs-step-title">Paso 1</p>
        <p class="browser-faqs-step-text">Entrá a <span>“Configuración”.</span></p>
      </div>
    </div>

    <div class="browser-faqs-step right-img">
      <div class="browser-faqs-step-info">
        <p class="browser-faqs-step-title">Paso 2</p>
        <p class="browser-faqs-step-text">Bajá por las opciones hasta encontrar <span>“Safari”</span> y presionalo para ingresar.</p>
      </div>
      <figure class="browser-faqs-step-img">
        <img src="https://www.clarin.com/images/collections/faqs/ios-2___68ff8e8d052c970019fbe6ba.png" alt="Paso 2">
      </figure>
    </div>

    <div class="browser-faqs-step left-img">
      <figure class="browser-faqs-step-img">
        <img src="https://www.clarin.com/images/collections/faqs/ios-3___68ff8d1a052c970019fbe6b7.gif" alt="Paso 3">
      </figure>
      <div class="browser-faqs-step-info">
        <p class="browser-faqs-step-title">Paso 3</p>
        <p class="browser-faqs-step-text">Apagá los botones ubicados a la derecha de las opciones <span>“Evitar rastreo entre sitios”</span> y <span>“Bloquear todas las cookies”</span><br><br><em>* Para asegurarte de que los botones se hayan apagado correctamente, deberán quedar en blanco como se muestra en la imagen.</em></p>
      </div>
    </div>

    <div class="browser-faqs-step right-img">
      <div class="browser-faqs-step-info">
        <p class="browser-faqs-step-title">Paso 4</p>
        <p class="browser-faqs-step-text">Finalmente ingresá a <span>Clarin.com</span> para continuar leyendo sin problemas.</p>
      </div>
      <figure class="browser-faqs-step-img">
        <img src="https://www.clarin.com/images/collections/faqs/ios-4___68ff8d19052c970019fbe6b6.gif" alt="Paso 4">
      </figure>    
    </div>

    <div class="browser-faqs-others">
        <p class="browser-faqs-others-title">También te puede interesar</p>
        <div class="browser-faqs-others-options">
            <a class="browser-faqs-others-options-link" href="https://www.clarin.com/preguntas-frecuentes/safari.html">¿Cómo habilitar cookies de terceros en navegadores Safari para MAC?</a>
            <a class="browser-faqs-others-options-link" href="https://www.clarin.com/preguntas-frecuentes/chrome.html">¿Cómo habilitar cookies de terceros en navegadores Chrome?</a>
            <a class="browser-faqs-others-options-link" href="https://www.clarin.com/preguntas-frecuentes/ie.html">¿Cómo habilitar cookies de terceros en navegadores Explorer?</a>
            <a class="browser-faqs-others-options-link" href="https://www.clarin.com/preguntas-frecuentes/firefox.html">¿Cómo habilitar cookies de terceros en navegadores Firefox?</a>
            <a class="browser-faqs-others-options-link" href="https://www.clarin.com/preguntas-frecuentes">Preguntas frecuentes</a>
        </div>
    </div>
    `,
  },

  "tutorial-registro-ingreso": {
    title: "¿Cómo ingresar con tu cuenta a Clarín y Olé?",
    content: `
    <div class="browser-faqs-hero">
      <h2 class="browser-faqs-title">¿Cómo ingresar con tu cuenta a Clarín y Olé?</h2>
      <figure class="browser-faqs-img">
        <img src="https://www.clarin.com/images/collections/faqs/dispositivos___68ffc81a052c970019fbe6cb.png"
        alt="Dispositivos"/>
      </figure>
    </div>

      <div class="browser-faqs-tutorial">
        <p class="browser-faqs-tutorial-title">¿Con qué tipo de cuenta estás registrado?</p>
        <ul class="browser-faqs-tutorial-list types">
          <li class="browser-faqs-tutorial-list-item"><a href="#email"><div class="type">Correo electónico<img src="https://www.clarin.com/images/collections/faqs/arrow___68ffb5f7c0ec7a0018988541.png" alt="Flecha"/></div></a></li>
          <li class="browser-faqs-tutorial-list-item"><a href="#facebook"><div class="type"><span><img src="https://www.clarin.com/images/collections/faqs/facebook___68ffb5f7c0ec7a0018988542.png" alt="Facebook"/>Facebook</span><img src="https://www.clarin.com/images/collections/faqs/arrow___68ffb5f7c0ec7a0018988541.png" alt="Flecha"/></div></a></li>
          <li class="browser-faqs-tutorial-list-item"><a href="#google"><div class="type"><span><img src="https://www.clarin.com/images/collections/faqs/google___68ffb5f7c0ec7a0018988543.png" alt="Google"/>Google</span><img src="https://www.clarin.com/images/collections/faqs/arrow___68ffb5f7c0ec7a0018988541.png" alt="Flecha"/></div></a></li>
          <li class="browser-faqs-tutorial-list-item"><a href="#apple"><div class="type"><span><img src="https://www.clarin.com/faqs/bundles/faqs/img/preguntas-frecuentes/registro-ingreso/apple.png?9a7c1ec" alt="Apple"/>Apple</span><img src="https://www.clarin.com/images/collections/faqs/arrow___68ffb5f7c0ec7a0018988541.png" alt="Flecha"/></div></a></li>
        </ul>
      </div>

      <div class="browser-faqs-tutorial grey" id="email">
        <p class="browser-faqs-tutorial-title">Si estás registrado con <span>correo electrónico</span>, seguí estos pasos:</p>
        <div class="browser-faqs-tutorial-info">
          <figure class="browser-faqs-tutorial-img">
            <img src="https://www.clarin.com/images/collections/faqs/login___68ffb5f7c0ec7a0018988544.gif" alt="Login"/>
          </figure>
            <ol class="browser-faqs-tutorial-list">
                <li class="browser-faqs-tutorial-list-item">Ingresá tu correo electrónico.</li>
                <li class="browser-faqs-tutorial-list-item">Dale click a <span>Continuar</span>.</li>
                <li class="browser-faqs-tutorial-list-item">Completá tu contraseña.</li>
                <li class="browser-faqs-tutorial-list-item">Clickeá <span>Continuar</span> nuevamente.</li>
            </ol>
        </div>
      </div>

      <div class="browser-faqs-tutorial grey" id="password">
        <p class="browser-faqs-tutorial-title">¿Olvidaste tu contraseña?</p>
        <div class="browser-faqs-tutorial-info">
          <figure class="browser-faqs-tutorial-img">
            <img src="https://www.clarin.com/images/collections/faqs/login-password___68ffb5f9052c970019fbe6ca.gif" alt="Login Password"/>
          </figure>
          <ol class="browser-faqs-tutorial-list">
              <li class="browser-faqs-tutorial-list-item">Ingresá tu correo electrónico.</li>
              <li class="browser-faqs-tutorial-list-item">Dale click a <span>Continuar</span>.</li>
              <li class="browser-faqs-tutorial-list-item">Seleccioná <span>¿Olvidaste tu contraseña?</span></li>
              <li class="browser-faqs-tutorial-list-item">Validá que tu correo electrónico sea correcto.</li>
              <li class="browser-faqs-tutorial-list-item">Clickeá en <span>Enviar correo electrónico</span>.</li>
              <li class="browser-faqs-tutorial-list-item">Abrí tu correo electrónico y seleccioná<br/><span>Recuperar contraseña</span>.</li>
              <li class="browser-faqs-tutorial-list-item">Ingresá tu nueva contraseña. </li>
          </ol>
        </div>
      </div>

      <div class="browser-faqs-tutorial" id="facebook">
          <p class="browser-faqs-tutorial-title">Si estás registrado con <span>Facebook</span>, tendrás que:</p>
          <div class="browser-faqs-tutorial-info">
            <figure class="browser-faqs-tutorial-img">
              <img src="https://www.clarin.com/images/collections/faqs/login-facebook___68ffb5f8c0ec7a0018988545.gif" alt="Login Facebook"/>     
            </figure>  
            <div class="browser-faqs-tutorial-list-container">       
              <ol class="browser-faqs-tutorial-list">
                  <li class="browser-faqs-tutorial-list-item">Seleccionar "Continuar con Facebook".</li>
                  <li class="browser-faqs-tutorial-list-item">Ingresar tus datos de registro en Facebook.</li>
              </ol>
              <p class="browser-faqs-tutorial-list-text">El correo electrónico y la clave son los que usás para entrar a la red social. Si ya estás registrado en el dispositivo, directamente aceptá el acceso.</p>
            </div>
          </div>
      </div>

      <div class="browser-faqs-tutorial grey" id="google">
          <h2 class="browser-faqs-tutorial-title">Si estás registrado con <span>Google</span>, tendrás que:</h2>
          <div class="browser-faqs-tutorial-info">
            <figure class="browser-faqs-tutorial-img">
              <img src="https://www.clarin.com/images/collections/faqs/login-google___68ffb5f8c0ec7a0018988546.gif" alt="Login Google"/>
            </figure>
            <div class="browser-faqs-tutorial-list-container">
                <ol class="browser-faqs-tutorial-list">
                    <li class="browser-faqs-tutorial-list-item">Seleccionar "Continuar con Google".</li>
                    <li class="browser-faqs-tutorial-list-item">Ingresar tus datos de registro en Google.</li>
                </ol>
                <p class="browser-faqs-tutorial-list-text">El correo electrónico y la clave son los que usás para entrar en tu mail. Si ya estás registrado en el dispositivo, directamente aceptá el acceso.</p>
            </div>
          </div>
      </div>

      <div class="browser-faqs-tutorial" id="google">
          <h2 class="browser-faqs-tutorial-title">Si estás registrado con <span>Apple</span>, tendrás que:</h2>
          <div class="browser-faqs-tutorial-info">
            <figure class="browser-faqs-tutorial-img">
              <img src="https://www.clarin.com/images/collections/faqs/login-apple___68ffb5f9052c970019fbe6c9.gif" alt="Login Apple"/>
            </figure>
            <ol class="browser-faqs-tutorial-list">
                <li class="browser-faqs-tutorial-list-item">Seleccionar "Continuar con Apple".</li>
                <li class="browser-faqs-tutorial-list-item">Ingresar tus datos de registro en Apple ID.</li>
                <li class="browser-faqs-tutorial-list-item">Aceptar el ingreso de Auth0 Login Service con tu correo electrónico.</li>
            </ol>
          </div>
      </div>
    `,
  },
};
